import React from "react";
import Marquee from "react-fast-marquee";
const MarqueeOne = () => {
  return (
    <div className="marquee-area bg-smoke">
      <div className="container-fluid p-0 overflow-hidden">
        <div className="slider__marquee">
          <div className="marquee_mode">
            <Marquee speed={100}>
              <div className="item">

                <img src="assets/img/icon/marquee-icon-1-2.svg" alt="img" />
                <span className="text-stroke">SUPPLY SERVICE</span>

              </div>
              <div className="item">

                <img src="assets/img/icon/marquee-icon-1-1.svg" alt="img" />
                <span>HEAVY EQUIPMENT SUPPLY</span>

              </div>
              <div className="item">

                <img src="assets/img/icon/marquee-icon-1-2.svg" alt="img" />
                <span className="text-stroke">PERSONEL SUPPLY</span>

              </div>
              <div className="item">

                <img src="assets/img/icon/marquee-icon-1-1.svg" alt="img" />
                <span>CONSTRUCTION</span>

              </div>
            </Marquee>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarqueeOne;
